import Price from '../../../../appData/price'
import { useBlackFriday } from '../../../../context/blackFridayContext'
import useStrings from '../../../../localization/useStrings'
import styles from './PromoRegularFooter.module.scss'

const PromoRegularFooter = () => {
  const { state, actions } = useBlackFriday()
  const strings = useStrings()

  const monthlyPrice = new Price(
    state.currentPricing.baseProduct.price,
    state.currentPricing.baseProduct.priceLocale
  ).formatted

  const yearlyPrice = state.currentPricing.yearlyPriceFull.formatted
  const yearlyPriceDiscounted = state.currentPricing.yearlyPriceDiscounted.formatted

  return (
    <div className={styles.container}>
      <div className={styles.spacer} />
      <div className={styles.buttonContainer}>
        <button
          className={`${styles.button} ${styles.buttonYearly}`}
          onClick={() => {
            actions.purchaseYearly()
          }}
        >
          <div className={styles.discount}>{strings.save(state.currentPricing.savingPercent)}</div>
          <div className={styles.yearlyContainer}>
            <label>{strings.blackFridayAnnualTitle}</label>
            <label>{strings.oneYear}</label>
          </div>
          <div className={styles.yearlyPriceContainer}>
            <label className={styles.yearlyPriceOriginal}>{yearlyPrice}</label>
            <label className={styles.yearlyPriceDiscounted}>{yearlyPriceDiscounted}</label>
          </div>
        </button>
      </div>
      <div className={`${styles.buttonContainer} ${styles.monthlyContainer}`}>
        <button
          className={`${styles.button} ${styles.buttonMonthly}`}
          onClick={() => {
            actions.purchaseMonthly()
          }}
        >
          <label>{strings.oneMonth}</label>
          <label>{monthlyPrice}</label>
        </button>
      </div>
    </div>
  )
}

export default PromoRegularFooter
